/**
 * The wire contract of the LubeHub API, as TypeScript.
 *
 * These describe what the backend **says it returns** — they are a map, not a
 * guarantee. Nothing here validates anything at runtime: a type cannot stop a
 * server sending something else. Where a value must be trusted, validate it.
 * See `docs/API_CONVENTIONS.md` in the backend repository, which these mirror.
 */
/**
 * The stable machine-readable error codes.
 *
 * Clients branch on these, **never** on `message` — the message is a
 * human-readable summary that may be reworded at any time, while a code is
 * part of the v1 contract and does not change meaning once shipped.
 *
 * A string union rather than an enum: enums are not erasable and conflict with
 * the workspace's `isolatedModules`/`verbatimModuleSyntax`.
 */
export const API_ERROR_CODES = [
    'MALFORMED_JSON',
    'BAD_REQUEST',
    'UNAUTHENTICATED',
    'INVALID_CREDENTIALS',
    'FORBIDDEN',
    'NOT_FOUND',
    'METHOD_NOT_ALLOWED',
    'CONFLICT',
    'UNSUPPORTED_MEDIA_TYPE',
    'VALIDATION_FAILED',
    'RATE_LIMITED',
    'SERVER_ERROR',
    'SERVICE_UNAVAILABLE',
    'FEATURE_DISABLED',
    'APP_MAINTENANCE',
    'APP_UPDATE_REQUIRED',
    'INVALID_CONFIGURATION',
];
export function isApiErrorBody(value) {
    if (typeof value !== 'object' || value === null || !('error' in value)) {
        return false;
    }
    const { error } = value;
    if (typeof error !== 'object' || error === null || !('code' in error)) {
        return false;
    }
    return typeof error.code === 'string';
}
//# sourceMappingURL=envelope.js.map